module.exports = __webpack_public_path__ + "media/images/countryrect/bn-8b4dbb8de4bff1cac63e3554de2e9f14.svg";